import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Button,
  TextField,
  Select,
  MenuItem,
  Typography,
  Slider,
  Card,
  makeStyles,
} from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from '../firebase/firebaseConfig';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: '5%',
    padding: '10px',
  },
  form: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '25px 10px',
    justifyItems: 'stretch',
    alignItems: 'center',
    '@media (max-width: 610px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'inherit',
      paddingLeft: '20px',
      paddingRight: '20px',
    },

    marginBottom: '20px',
  },

  phone: {
    '@media (max-width: 363px)': {
      width: '100%',
    },
  },

  title: {
    textAlign: 'center',
  },
  button: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  error: {
    textAlign: 'center',
    fontStyle: 'italic',
    color: 'red',
  },
}));

const levelMarks = [
  {
    value: 10,
    label: 'Beginner',
  },
  {
    value: 40,
    label: 'Intermediate',
  },
  {
    value: 70,
    label: 'Advanced',
  },
];

const EditUserForm = ({ user }) => {
  const classes = useStyles();

  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    phone: '',
    dob: new Date(),
    lang: '',
    password: '',
    salsaLevel: 0,
    bachataLevel: 0,
    referredBy: 'N/A',
    classStats: {
      classesRemaining: 0,
      classesTaken: 0,
    },
    uid: '',
    // classes: 0,
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setNewUser({ ...user });
  }, [user]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const editUser = async (e, reason) => {
    e.preventDefault();

    try {
      //Grab the current user uid
      //Merge new data with the user
      await firebase
        .firestore()
        .collection('class_accounts')
        .doc(newUser.uid.trim())
        .update(
          {
            ...newUser,
          },
          { merge: true }
        );
      handleClick(e, reason);
    } catch (err) {
      console.log('Error', err);
    }
  };
  return (
    <div>
      <h4 align='center'>Edit User</h4>
      <form className={classes.form} autoComplete='off' onSubmit={editUser}>
        <TextField
          style={{ gridColumn: '1 / span 1' }}
          value={newUser.name}
          onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
          required
          label={'Name'}
          variant='outlined'
        />
        <MuiPickersUtilsProvider
          style={{ gridColumn: '2 / span 1' }}
          utils={DateFnsUtils}
        >
          <KeyboardDatePicker
            margin='normal'
            label={'Date of Birth'}
            format='MM/dd/yyyy'
            value={newUser.dob}
            onChange={(newDate) => setNewUser({ ...newUser, dob: newDate })}
          />
        </MuiPickersUtilsProvider>
        <TextField
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          required
          label={'Email'}
          variant='outlined'
        />
        <TextField
          value={newUser.password}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          type='password'
          required
          label={'Password'}
          variant='outlined'
        />
        <PhoneInput
          className={classes.phone}
          inputProps={{
            name: 'Enter Your Phone Number',
          }}
          country={'us'}
          value={newUser.phone}
          onChange={(phone) => setNewUser({ ...newUser, phone })}
        />

        {/* Preferred Language */}

        <FormControl>
          <InputLabel id='signup-lang-label'>
            {'Language Preference'}
          </InputLabel>
          <Select
            value={newUser.lang}
            onChange={(e) => setNewUser({ ...newUser, lang: e.target.value })}
            labelId='signup-lang-label'
          >
            <MenuItem value={'English'}>English</MenuItem>
            <MenuItem value={'Español'}>Español</MenuItem>
          </Select>
        </FormControl>

        <div>
          <Typography gutterBottom>{'Salsa Level'}</Typography>
          <Slider
            value={newUser.salsaLevel}
            onChange={(e, newValue) =>
              setNewUser({ ...newUser, salsaLevel: newValue })
            }
            //getAriaValueText={valuetext}
            //aria-labelledby='discrete-slider-always'
            step={10}
            marks={levelMarks}
            // valueLabelDisplay='on'
          />
        </div>
        <div>
          <Typography gutterBottom>{'Bachata Level'}</Typography>
          <Slider
            value={newUser.bachataLevel}
            onChange={(e, newValue) =>
              setNewUser({ ...newUser, bachataLevel: newValue })
            }
            //getAriaValueText={valuetext}
            //aria-labelledby='discrete-slider-always'
            step={10}
            marks={levelMarks}
            // valueLabelDisplay='on'
          />
        </div>
        <TextField
          value={newUser.classStats.classesRemaining}
          onChange={(e) =>
            setNewUser({
              ...newUser,
              classStats: {
                classesRemaining: Number(e.target.value),
                classesTaken: newUser.classStats.classesTaken,
              },
            })
          }
          required
          label={'Classes Remaining'}
          type='number'
        />
        <TextField
          value={newUser.classStats.classesTaken}
          onChange={(e) =>
            setNewUser({
              ...newUser,
              classStats: {
                classesRemaining: newUser.classStats.classesRemaining,
                classesTaken: Number(e.target.value),
              },
            })
          }
          required
          label={'Classes Taken'}
          type='number'
        />

        <TextField
          value={newUser.referredBy}
          onChange={(e) =>
            setNewUser({ ...newUser, referredBy: e.target.value })
          }
          required
          label={'Who referred you?'}
        />
        <Button
          className={classes.button}
          type='submit'
          variant='contained'
          color='secondary'
        >
          Edit User
        </Button>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={`${newUser.name}'s profile has been updated.`}
          action={
            <React.Fragment>
              <IconButton
                size='small'
                aria-label='close'
                color='inherit'
                onClick={handleClose}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </React.Fragment>
          }
        />
      </form>
    </div>
  );
};

export default EditUserForm;
